import type { Database } from 'node-sqlite3-wasm';
import { getParentFileMapHash } from './parent-file-map.js';
import type { SymbolIndexParentContext } from './parent-context.js';

/** Resolved content hash for a file, or null when absent / tombstoned. */
export function getEffectiveContentHash(
  db: Database,
  ctx: SymbolIndexParentContext,
  filePath: string,
): string | null {
  const overlayHash = getParentFileMapHash(db, ctx.parentId, filePath);
  if (overlayHash !== undefined) return overlayHash;
  if (ctx.baseParentId == null) return null;
  const baseHash = getParentFileMapHash(db, ctx.baseParentId, filePath);
  if (baseHash === undefined) return null;
  return baseHash;
}

export function listEffectiveIndexedFilePaths(db: Database, ctx: SymbolIndexParentContext): string[] {
  const paths = new Set<string>();
  if (ctx.baseParentId != null) {
    const baseRows = db.all('SELECT file_path FROM symbol_parent_file_map WHERE parent_id = ? AND content_hash IS NOT NULL', [
      ctx.baseParentId,
    ]) as Array<{ file_path: string }>;
    for (const row of baseRows) paths.add(row.file_path);
  }

  const overlayRows = db.all('SELECT file_path, content_hash FROM symbol_parent_file_map WHERE parent_id = ?', [
    ctx.parentId,
  ]) as Array<{ file_path: string; content_hash: string | null }>;
  for (const row of overlayRows) {
    if (row.content_hash == null) paths.delete(row.file_path);
    else paths.add(row.file_path);
  }

  if (ctx.baseParentId == null) {
    const ownRows = db.all('SELECT file_path FROM symbol_parent_file_map WHERE parent_id = ? AND content_hash IS NOT NULL', [
      ctx.parentId,
    ]) as Array<{ file_path: string }>;
    for (const row of ownRows) paths.add(row.file_path);
  }

  return [...paths];
}
